import { trackEvent } from './analytics';

export const analyticsEvents = {
  loginSuccess: (role) => trackEvent('login', { user_role: role || 'unknown' }),
  loginFailure: (reason) => trackEvent('login_error', { reason }),
  signUpStart: () => trackEvent('sign_up_start'),
  signUpSuccess: (method = 'email') => trackEvent('sign_up', { method }),
  signUpFailure: (reason) => trackEvent('sign_up_error', { reason }),
  signUpVerificationSent: (existingAccount = false) =>
    trackEvent('verification_email_sent', { existing_account: existingAccount }),
  forgotPasswordRequested: () => trackEvent('forgot_password_request'),
  resetPasswordSuccess: () => trackEvent('password_reset_success'),
  reportSubmitAttempt: (reportType = 'anonymous') =>
    trackEvent('report_submit_attempt', { report_type: reportType }),
  reportSubmitSuccess: (reportType = 'anonymous', hasAttachments = false) =>
    trackEvent('generate_lead', { report_type: reportType, has_attachments: hasAttachments }),
  reportSubmitFailure: (reportType = 'anonymous') =>
    trackEvent('report_submit_error', { report_type: reportType }),
  exportAnalyticsPdf: (period) => trackEvent('export_analytics_pdf', { period }),
  languageChange: (language) => trackEvent('language_change', { content_language: language }),
};
